import React, { useEffect } from "react"

const HubspotPartnershipsForm = () => {
  useEffect(() => {
    // Load the HubSpot script dynamically
    const script = document.createElement('script');
    script.src = '//js-eu1.hsforms.net/forms/embed/v2.js';
    script.async = true;
    script.onload = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: "eu1",
          portalId: "141862351",
          formId: "2f183822-e508-4e7b-8e27-8a76ef1c34db",
          target: '#hubspot-form'
        });
      }
    };
    document.body.appendChild(script);

    // Clean up on component unmount
    return () => {
      document.body.removeChild(script);
    };
  });

  return <div id="hubspot-form"></div>;
};

export default HubspotPartnershipsForm;
